import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private notificationSubject = new BehaviorSubject<string>(null);
  notification = this.notificationSubject.asObservable();

  constructor() { }

  notify(msg: string) {
    this.notificationSubject.next(msg);
    setTimeout(() => this.notificationSubject.next(null), 3000);
  }
}
